/*
 * @Author: wuqinfa
 * @Date: 2024-01-11 23:07:08
 * @LastEditors: Please set LastEditors
 * @Description: 
 */
import request from '@/utils/request';
// import qs from 'qs';

const ACT_URL = process.env.VUE_APP_ACT_URL;
const SERVER_URL = process.env.VUE_APP_SERVER_URL;

export async function getCurrentUser(token) {
  if (!token) {
    return await request.get('/user/getCurrentUser');
  }

  return await request.get('/user/getCurrentUser', {
    headers: {
      'mxcuser-token': token,
    },
  });
}

export async function loginAndRegister(opt) {
  return await request.get(`${SERVER_URL}/user/phoneLogin`, {
    params: opt,
  });
}

/** 使用账号密码登录。 */
export async function loginWithPassword(opt) {
  return await request.get(`${SERVER_URL}/user/login`, {
    params: opt,
  });
}

/**
 * 滑动验证码校验
 */
export async function captchaVerify(opt) {
  return await request.post(`${SERVER_URL}/common/captchaVerify`, opt, {
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function sendSMS2(opt) {
  // return await request.get(`${SERVER_URL}/ccbb/sendSMS2`, {
  return await request.get(`${SERVER_URL}/ccbb/captcha/sendSMS2`, {
    params: opt,
  });
}

export async function uploadMaterial(opt) {
  return await request.post('/mate/uploadMaterial', opt);
}

// 等级考试活动展示
export async function showActivity(opt) {
  return await request.get(`${ACT_URL}/gzactivity/levelExamActivity/showActivity`, {
    params: opt,
  });
}

// 获取用户赛考活动状态详情
export async function getUserActivityStatus(opt) {
  const config = {
    params: opt,
  };

  if (opt && opt.token) {
    config.headers = {
      'mxcuser-token': opt.token,
    };
  }
  
  return await request.get(`${ACT_URL}/gzactivity/levelExamActivity/getShowAuditDetail`, config);
}

// 获取用户赛考活动状态详情
export async function submitEnrollInfo(opt) {
  return await request.post(
    `${ACT_URL}/gzactivity/levelExamActivity/submitEnrollInfo`,
    opt,
    { headers: { 'Content-Type': 'application/json' } },
  );
}

// 获取用户报名详情
export async function getEnrollRecord(opt) {
  return await request.get(`${ACT_URL}/gzactivity/levelExamActivity/getEnrollRecord`, {
    params: opt,
  });
}

// 获取图文资源
export async function getResourceImg(opt) {
  return await request.get(`${ACT_URL}/gzactivity/levelExamActivity/getResourceImg`, {
    params: opt,
  });
}

// 报考记录
export async function getEnrollRecordList(opt) {
  if (!opt || !opt.token) {
    return await request.get(`${ACT_URL}/gzactivity/levelExamActivity/getEnrollRecordList`);
  }

  return await request.get(`${ACT_URL}/gzactivity/levelExamActivity/getEnrollRecordList`, {
    headers: {
      'mxcuser-token': opt.token,
    },
  });
}



// WEBPACK FOOTER //
// ./src/pages/exam-v2/services/api.js